/*eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import {
  setAddress,
  setProviderType,
  resetSearchParams,
  setSearchResults,
  setFilterChangeStatus,
  resetSortingChangeStatus,
  setSearchProviderParams,
  setShowAllFiltersPanel,
} from '../../../../redux/member/priceCompareSlice';
import DoctorSearchResults from '../find-doctor/search-results';
import CignaRoasterSearchResults from '../find-doctor/search-results/CignaRoasterSearchResults';
//import DoctorSearchResultsClientPagination from '../find-doctor/search-results-client-pagination';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import './SearchResults.scss';
import PriceCompareSearch from '../PriceCompareSearch';
import backBtn from '../../../img/pricecompare/back-btn.svg';
import SearchPageSkeleton from '../skeleton/SearchPageSkeleton';

import {
  getDoctorDetails,
  getPriceComaperFilters,
  searchProvidersPC,
} from 'src/redux/member/api-calls/priceCompare';
import { CLIENT_TYPES } from 'src/constants';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { ConfigurationSVG } from 'src/Admin/img/GlobalSVG';

const SearchResults = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { searchParamsForUI } = useSelector((state) => state.priceCompare);
  const {
    address,
    providerType,
    searchResults,
    isSearchingProviders,
    searchProviderParams,
  } = useSelector((state) => state.priceCompare);
  const {
    Display_Network_For_PriceComparison_Member,
    Value_Network_For_PriceComparison_Member,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const { PriceComparison_Setting } = useSelector(
    (state) => state?.app?.appConfigs,
  );
  const [isProvidersActive, setProvidersActive] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [modifySearch, setModifySearch] = useState(false);
  const [modify, setModify] = useState(false);
  const [isEditingSearch, setIsEditingSearch] = useState(false);
  const [resetAllFiltersFocus, setResetAllFiltersFocus] = useState(false);
  const [applyAllFiltersPanelFocus, setApplyAllFiltersPanelFocus] =
    useState(false);
  const searchProviderFiltersChanged = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderFiltersChanged,
  );
  const searchProvidersSortingChanged = useSelector(
    ({ priceCompare }) => priceCompare.searchProvidersSortingChanged,
  );
  const { sortby, sortdirection, selectedNetwork } = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams,
  );

  const disclaimerText = PriceComparison_Setting.Disclaimer;

  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);

  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };

  console.log('selectedNetwork is selectedNetwork >>>>>', selectedNetwork);

  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    if (searchProviderFiltersChanged === true) {
      dispatch(setFilterChangeStatus(false));
      dispatch(searchProvidersPC());
      dispatch(getPriceComaperFilters());
    }
  }, [searchProviderFiltersChanged]);

  useEffect(() => {
    if (searchProvidersSortingChanged === true) {
      dispatch(resetSortingChangeStatus());
      dispatch(searchProvidersPC());
    }
  }, [searchProvidersSortingChanged]);
  useEffect(() => {
    dispatch(searchProvidersPC());
    setModify(false);
  }, [searchParamsForUI]);
  useEffect(() => {
    if (location.state === undefined || !address) {
      navigate('/member/price-compare');
    }
    dispatch(searchProvidersPC());
  }, []);

  const searchInitiationHandler = () => {
    setShowSearchResults(true);
    setModifySearch(true);
    setIsEditingSearch(true);
  };
  const pageInfo = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const modifySearchHandler = () => {
    setModifySearch(false);
    searchInitiationHandler();
    dispatch(setSearchProviderParams({ pagenumber: 1 }));
    //dispatch(searchProviderFiltersInitial()); // #resolution 1 to reset filter on modify
  };

  const getSearchInformation = () => {
    let searchInfo = '';
    if (providerType === 'doctors') {
      searchInfo =
        searchProviderParams.DoctorByName != null
          ? ' / ' + searchProviderParams.DoctorByName
          : ' / ' + searchProviderParams.DoctorByType[0];
    } else {
      searchInfo =
        searchProviderParams.FacilityByName != null
          ? ' / ' + searchProviderParams.FacilityByName
          : ' / ' + searchProviderParams.FacilityByType[0];
    }
    return searchInfo;
  };
  const goBack = () => {
    navigate('/member/price-compare');
  };

  const [skeletonShownCount, setSkeletonShownCount] = useState(0);

  useEffect(() => {
    if (selectedNetwork?.ProviderDirectory === 'R') {
      if (isSearchingProviders === true && skeletonShownCount === 0) {
        setSkeletonShownCount(skeletonShownCount + 1);
      }
    }
  }, [isSearchingProviders]);
  //Function to update the list data with covered cost
  function updateAndFilterData(arr1, arr2) {
    //Create a map to store resp2 objects based on their (npi, data) as a key
    const resp2Map = new Map();
    arr2.forEach((obj) => {
      const key = `${obj?.NPI}-${obj?.TIN}`;
      const value = obj?.Rate === 'null' ? null : obj?.Rate;
      resp2Map.set(key, { Rate: value });
    });

    //Filter and update resp1 based on resp2
    const updatedData = arr1
      .filter((obj1) => {
        const key = `${obj1?.NationalProviderId}-${obj1?.TaxID}`;
        return resp2Map.has(key);
      })
      .map((obj1) => {
        const key = `${obj1?.NationalProviderId}-${obj1?.TaxID}`;
        return { ...obj1, ...resp2Map.get(key) };
      });

    return updatedData;
  }

  const [coveredCostLoading, setCoveredCostLoading] = useState(false);

  const getCoveredCostHandler = async () => {
    setCoveredCostLoading(true);
    const COVERED_COST_API_PAYLOAD = {
      FetchMrfprice: {
        ProcedureCodeType: searchParamsForUI?.helthProcedureData?.codeName,
        ProcedureCode: searchParamsForUI?.helthProcedureData?.value,
        NetworkCode: 'CIGNA',
        RequestId: '12346',
        NpiRecord: searchResults?.data?.map((item) => {
          if (item?.NationalProviderId && item?.TaxID) {
            return {
              NPI: item?.NationalProviderId,
              TIN: item?.TaxID,
            };
          }
        }),
      },
    };
    try {
      const response = await axiosInstance.post(
        APIEndpoints.getCoveedCost(),
        COVERED_COST_API_PAYLOAD,
      );
      const reduxSearchedData = [...searchResults.data];
      if (response?.data?.TinNpiRecord?.length > 0) {
        //Call the function and get the updated list
        const updatedData = updateAndFilterData(
          reduxSearchedData,
          response?.data?.TinNpiRecord,
        );
        dispatch(setSearchResults({ ...searchResults, data: updatedData }));
        console.log('debug_response FetchMrfprice', response);
      }
    } catch (err) {
      console.log('debug_err', err);
    } finally {
      setCoveredCostLoading(false);
    }
  };

  const onResetFiltersClick = (val) => {
    setResetAllFiltersFocus(val);
  };

  const onApplyFiltersPanelClick = (val) => {
    setApplyAllFiltersPanelFocus(val);
  };

  useEffect(() => {
    setTimeout(() => {
      if (
        searchResults?.data?.length &&
        isSearchingProviders === false &&
        PriceComparison_Setting?.ENABLE_ZPH_INTEGRATION &&
        searchProviderParams?.selectedNetwork?.ProviderDirectory === 'R'
      ) {
        getCoveredCostHandler();
      }
    }, 100);
  }, [isSearchingProviders]);

  useEffect(() => {
    if (resetAllFiltersFocus) {
      setTimeout(() => {
        if (pageInfo && pageInfo.current) {
          pageInfo.current.focus();
        }
      }, 10);
    }
  }, [resetAllFiltersFocus]);

  useEffect(() => {
    if (applyAllFiltersPanelFocus) {
      setTimeout(() => {
        if (pageInfo && pageInfo.current) {
          pageInfo.current.focus();
        }
      }, 10);
    }
  }, [applyAllFiltersPanelFocus]);

  return (
    <div className="price-compare-result-container">
      <span
        className="sr-only"
        role="heading"
        aria-level={1}
        tabIndex={-1}
        ref={pageInfo}
      >
        {t('member.price_comparison.accessibility_page_info')}
      </span>
      {!modify && (
        <div className="container p-0">
          <div>
            <div className="header-container">
              <div className="d-flex align-items-center">
                <span>
                  <img
                    className="back-btn-to-serach-page"
                    src={backBtn}
                    role="button"
                    alt="Click to Go Back"
                    onClick={() => goBack()}
                  />
                </span>
                <h1 className="content-header ml-1" aria-hidden={true}>
                  {t('member.price_comparison.heading_text_compare')}{' '}
                  <span className="content-header-bold">
                    {t('member.price_comparison.heading_text_price')}
                  </span>
                </h1>
              </div>
            </div>
          </div>
          <div className="find-provider-container">
            {isSearchingProviders && skeletonShownCount === 0 ? (
              <SearchPageSkeleton />
            ) : (
              <div>
                <div className="price-compare-sub-text-on-main">
                  {t('member.price_comparison.page_sub_heading')}
                  {/*<a className="learn-more" aria-hidden={true}>
                    {t('member.price_comparison.learn_more')}
            </a>*/}
                </div>
                <div>
                  <div
                    className="main-wrapper1 d-flex justify-content-between mt-3"
                    role="region"
                    aria-label={t(
                      'member.price_comparison.procedure_container.accessibility_container_info',
                    )}
                  >
                    <div className="top">
                      <div className="top-container">
                        <div>
                          <div className="service-provider">
                            <div className="text-container">
                              {t(
                                'member.price_comparison.procedure_container.container_text',
                              )}
                            </div>
                            <div className="flex-container">
                              <div className="search-result-data">
                                <span className="search-result-data-heading">
                                  {t(
                                    'member.price_comparison.procedure_container.service_for_label',
                                  )}
                                </span>
                                {location.state?.procedureForData?.label}
                                <span className="pipe">&nbsp;|&nbsp;</span>
                              </div>

                              <div className="search-result-data">
                                <span className="search-result-data-heading">
                                  {t(
                                    'member.price_comparison.procedure_container.health_procedure_label',
                                  )}
                                </span>
                                {location.state?.helthProcedureData?.label}
                                {location.state?.billedamount == '' ||
                                location.state?.billedamount === '0.00' ? (
                                  ''
                                ) : (
                                  <span className="pipe">&nbsp;|&nbsp;</span>
                                )}
                              </div>
                              {location.state?.billedamount == '' ||
                              location.state?.billedamount === '0.00' ? (
                                ''
                              ) : (
                                <div className="search-result-data">
                                  <span className="search-result-data-heading">
                                    {t(
                                      'member.price_comparison.procedure_container.billed_amount',
                                    )}{' '}
                                  </span>
                                  {`$${location.state?.billedamount}`}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="service-provider">
                            <div className="text-container">
                              {t(
                                'member.price_comparison.provider_container.container_text',
                              )}
                            </div>
                            <div className="flex-container">
                              <div className="search-result-data">
                                <span className="search-result-data-heading">
                                  {t(
                                    'member.price_comparison.provider_container.location_label',
                                  )}
                                </span>
                                {location.state?.locationData}
                                <span className="pipe">&nbsp;|&nbsp;</span>
                              </div>

                              <div className="search-result-data">
                                <span className="search-result-data-heading">
                                  {Display_Network_For_PriceComparison_Member &&
                                  Value_Network_For_PriceComparison_Member ===
                                    'tier'
                                    ? t(
                                        'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                      ) + ' : '
                                    : t(
                                        'member.price_comparison.provider_container.networks_dropdown_label',
                                      ) + ' : '}
                                </span>
                                {searchParamsForUI?.networksData?.label ||
                                  'All Plan Networks'}
                                {searchParamsForUI?.typesOfSpecialtyData
                                  ?.label && (
                                  <span className="pipe">&nbsp;|&nbsp;</span>
                                )}
                              </div>

                              {searchParamsForUI?.typesOfSpecialtyData
                                ?.label && (
                                <div className="search-result-data">
                                  <span className="search-result-data-heading">
                                    {location.state?.providerByData ===
                                    'doctor-name'
                                      ? t(
                                          'member.price_comparison.provider_container.by_doctor_name',
                                        )
                                      : location.state?.providerByData ===
                                        'doctor-type'
                                      ? t(
                                          'member.price_comparison.provider_container.by_doctor_specialty',
                                        )
                                      : location.state?.providerByData ===
                                        'facility-type'
                                      ? ' Facility Type'
                                      : ' Facility Name or Tax ID'}{' '}
                                    :{' '}
                                  </span>
                                  {location.state?.typesOfSpecialtyData?.label}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="button-container">
                      <div className="modify-btn-container">
                        <GenericButton
                          className="modify-filter-btn"
                          variant="secondary"
                          onClick={() => {
                            setModify(!modify);
                          }}
                          ariaLabel="Click to modify your services search criteria"
                        >
                          {t('member.price_comparison.modify_btn_label')}
                        </GenericButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="warning-parent mt-3">
            <div className="disclaimer-svg pt-1">
              <ConfigurationSVG.WarningSVG />
            </div>
            <div className="warning-content">
              <span className="content-bold">Disclaimer: {''}</span>
              <span className="disclaimer-text search-page-disclaimer-text">
                {' '}
                {disclaimerText}
              </span>
              {disclaimerText?.length > 80 && (
                <span className="button-position" aria-hidden={true}>
                  <GenericButton
                    variant="link"
                    className="viewmore-btn"
                    onClick={() => {
                      setisOpenDisclaimerPopup(!isOpenDisclaimerPopup);
                    }}
                  >
                    View More
                  </GenericButton>
                </span>
              )}
            </div>
          </div>
          {isOpenDisclaimerPopup && (
            <div>
              <Modal
                show={isOpenDisclaimerPopup}
                onHide={handleClose}
                centered
                className={`Right-Model member generic-model`}
              >
                <Modal.Header closeButton className="plandocument-header">
                  <Container className="px-0">
                    <Row className="align-items-center p-0 m-0">
                      <Col className="px-0">
                        <Modal.Title>Disclaimer</Modal.Title>
                      </Col>
                    </Row>
                  </Container>
                </Modal.Header>

                <Modal.Body className="disclaimer-body">
                  <Container className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container">
                    <div className="warning-content">{disclaimerText}</div>
                  </Container>
                </Modal.Body>

                <Modal.Footer className="admin bg-white footer-class disclaimer-footer-btn">
                  <div className="model-footer-btn txt-right p-0 m-0 border-0">
                    <button onClick={() => handleClose()} className="close-btn">
                      Close
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </div>
      )}
      {modify && <PriceCompareSearch label="modify search" />}

      {selectedNetwork?.ProviderDirectory === 'R' ? (
        <CignaRoasterSearchResults
          coveredCostLoading={coveredCostLoading}
          data={searchResults.data}
          pagination={searchResults.pagination}
          isSearchingProviders={isSearchingProviders}
          serachNetworksFor={
            searchParamsForUI?.networksData || {
              label: 'All Plan Networks',
              value: 'All Plan Networks',
            }
          }
          CoveredCostComparePriceArray={location.state}
          onResetFiltersClick={onResetFiltersClick}
          onApplyFiltersPanelClick={onApplyFiltersPanelClick}
        />
      ) : (
        <DoctorSearchResults
          data={searchResults?.data || []}
          coveredCostLoading={coveredCostLoading}
          pagination={searchResults.pagination}
          isSearchingProviders={isSearchingProviders}
          serachNetworksFor={
            searchParamsForUI?.networksData || {
              label: 'All Plan Networks',
              value: 'All Plan Networks',
            }
          }
          CoveredCostComparePriceArray={location.state}
          onResetFiltersClick={onResetFiltersClick}
          onApplyFiltersPanelClick={onApplyFiltersPanelClick}
        />
      )}
    </div>
  );
};

export default SearchResults;
